import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../services/maintenance.service';
import { tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountSplitResource } from 'src/app/client-api.service';
import { AccountSplitService } from './services/account-splits.service'
import { TableButton, TableColumn } from 'src/app/shared/tcc-ui/tables';

@Component({
  selector: 'app-account-split',
  templateUrl: './account-split.component.html',
  styles: [
  ]
})
export class AccountSplitComponent implements OnInit {

  allAccountSplits: AccountSplitResource[] | undefined;
  buttons: TableButton<any>[] | undefined;
  columns: TableColumn<AccountSplitResource>[] | undefined;
  filteredAccountSplits: AccountSplitResource[] | undefined;    
  AccountSplits$ = this.AccountSplitService.accountSplits$;
  state: 'initializing' | 'loading' | 'ready' | 'saving';

  constructor(private AccountSplitService: AccountSplitService,
              private maintenanceService: MaintenanceService,
              private activatedRoute: ActivatedRoute,
              private router: Router
  ) {
    this.state = 'initializing';  
    this.columns = [
          { title: 'Account Split Id', name: 'id', hidden: true },
          { title: 'Name', name: 'name' },
          { title: 'Type', name: 'type' },          
          { title: 'Org Code', name: 'orgCode' },
          { title: 'Account', name: 'account' },
          { title: 'Percentage', name: 'percentage' }          
        ];
    
        this.buttons = [
          {
            data: 'editManagementFeeSplit',
            iconClass: 'fas fa-pencil-alt',
            hidden: false,
            buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
            tooltip: 'Edit Management Fee Split'
          },
          {
            data: 'deleteManagementFeeSplit',
            iconClass: 'fas fa-trash-alt', 
            hidden: false,
            buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
            tooltip: 'Delete Management Fee Split'
          }
        ];
        this.AccountSplitService.setAccountSplits();
  }

  ngOnInit(): void {
     this.maintenanceService.setMaintenanceComponenetPanelSize('large');
      this.AccountSplits$.pipe(
        tap((o) => {
          this.allAccountSplits = o;
          this.filteredAccountSplits = o;
          this.state = 'ready';
        })
      ).subscribe();
  }

  deleteManagemenrFeeSplit(id: number) {
    if(confirm('Are you sure you want to delete this Managemenr Fee Split?')) {
      this.state = 'loading';
      this.AccountSplitService.deleteAccountSplit(id)
          .subscribe(
            res => {
              this.AccountSplitService.setAccountSplits();
              this.maintenanceService.setMaintenanceComponenetPanelSize('large');    
              this.state = 'ready';
            },
            err => {
              this.state = 'ready';
              alert('Error deleting Application View');
              this.maintenanceService.setMaintenanceComponenetPanelSize('large');    
            }
          );
    }        
  }

  filterManagemenrFeeSplit(event: any) {    
    const value = event.target.value;
    this.state = 'loading';
    this.filteredAccountSplits = this.allAccountSplits?.filter(a => JSON.stringify(a).toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.state = 'ready';
  }

  openManagementFeeSplitUpsertPanel(id: number) {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');      
    this.router.navigate(['upsert-management-fee-split/', id], { relativeTo: this.activatedRoute });
  }

  rowClicked(event: any) {
  if (event.button) {
            if (event.button.data === 'editManagementFeeSplit') {
        this.maintenanceService.setMaintenanceComponenetPanelSize('large');
        this.openManagementFeeSplitUpsertPanel(event.row?.id);
      }
      else if (event.button.data === 'deleteManagementFeeSplit') {
        this.deleteManagemenrFeeSplit(event.row?.id);
      }
    }
  }
}
